// src/helpers/getBaseUrl.js
const getBaseUrl = () => {
    if (process.env.NODE_ENV === 'production') {
      return process.env.REACT_APP_PROD;
    } else {
      return process.env.REACT_APP_DEV;
    }
  };
  
  export default getBaseUrl;